import { api } from 'utils/apis/api';
export const aiApi = api.injectEndpoints({
    endpoints: (builder) => ({
        createAiTextTranslation: builder.mutation({
            query: ({ language: language_code, text }) => ({
                version: 4,
                path: 'ai/text/translate',
                method: 'POST',
                body: {
                    language_code,
                    text,
                },
            }),
        }),
        createAiFeedback: builder.mutation({
            query: ({ feedbackId, feedback: body }) => ({
                version: 4,
                path: `ai/feedback/${feedbackId}`,
                method: 'POST',
                body,
            }),
        }),
    }),
});
